import React from 'react';
import { motion } from 'framer-motion';

export const EventNovaLogo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "h-6 w-6",
    md: "h-10 w-10",
    lg: "h-16 w-16"
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`relative ${sizes[size]} shrink-0`}>
        {/* Outer Ring */}
        <motion.div 
          animate={{ rotate: 360 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
          className="absolute inset-0 rounded-full border-2 border-dashed border-[#9D4EDD]/40"
        />
        {/* Inner Core */}
        <div className="absolute inset-1 rounded-lg bg-gradient-to-tr from-[#9D4EDD] via-[#7B2CBF] to-[#E5C158] shadow-[0_0_15px_rgba(157,78,221,0.5)] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20"></div>
          <span className="text-white font-black italic tracking-tighter relative z-10">N</span>
          {/* Flare */}
          <div className="absolute -top-1 -right-1 w-4 h-4 bg-white opacity-40 blur-sm rounded-full"></div>
        </div>
      </div>
      {size !== "sm" && (
        <div className="flex flex-col leading-none">
          <span className="text-white font-black tracking-tighter text-xl">EVENT<span className="text-[#E5C158]">NOVA</span></span>
          <span className="text-[9px] text-[#94A3B8] font-bold tracking-[0.3em] uppercase">Studio OS</span>
        </div>
      )}
    </div>
  );
};

export const AbstractPattern = ({ type = "dots", className = "" }) => {
  if (type === "nebula") {
    return (
      <div className={`absolute inset-0 opacity-20 pointer-events-none ${className}`}>
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#9D4EDD] blur-[100px] rounded-full"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#E5C158] blur-[80px] rounded-full"></div>
      </div>
    );
  }
  return (
    <div className={`absolute inset-0 opacity-5 pointer-events-none ${className}`} 
      style={{ backgroundImage: `radial-gradient(circle, #9D4EDD 1px, transparent 1px)`, backgroundSize: '24px 24px' }}>
    </div>
  );
};